import axios from 'axios';

export default {
  parseAddCutBudget(data) {
    return axios.post('/v2/budget/movement/parse', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  parseAddBudget(data) {
    return axios.post('/v2/budget/parse-bulk', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  submitAddCutBudget(data) {
    return axios.post('/v2/budget/movement/execute', data);
  },
  createBulk(data) {
    return axios.post('/v2/budget/submit-bulk', data);
  }
};
